export const CONVERSATION_SESSION_EVENTS_COLLECTION_NAME = 'conversationSessionEvents';
